const initialState = {
  newEvent: {}
}

const customerEventsReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case 'ADD_NEW_FAKE_CUSTOMER_EVENT':
      return {
        ...state,
        newEvent: payload
      };
    default:
      return state;
  }
};

export default customerEventsReducer;